import React, { Fragment } from 'react'
import BetId from './BetId'
import BetInfo from './BetInfo'
import Seeds from './Seed'
import { BETREPLY_CONTENT_PROPS } from './interface'

export default function BetReplyContent({
  content: { BET_ID, BET_INFO, SEED },
  func,
  children,
  colors,
  betInfo,
}: BETREPLY_CONTENT_PROPS) {
  return (
    <Fragment>
      <BetId content={BET_ID} />
      {children}
      {!betInfo && (
        <BetInfo
          content={BET_INFO}
          infoBoxBackgroundColor={colors.infoBoxBackgroundColor}
        />
      )}
      <Seeds
        content={SEED}
        func={func}
        colors={{ ...colors, majorTextColor: '#ffb000' }}
      />
    </Fragment>
  )
}
